import React from 'react';
import DefaultButton from 'components/Utils/NewDefaultButton';

const SaveButtonView = ({
  title,
  onClick = undefined,
  style = { width: '150px' },
  isLoading = false,
  isDisabled = false,
}) => (
  <div className="save-button row full-width">
    <DefaultButton
      name={title}
      onClick={onClick}
      style={style}
      loading={isLoading}
      disabled={isDisabled}
    />
  </div>
);

export default SaveButtonView;
